

/**
 *  碳排放模块
 * 
 * **/


let tkCommonTpf = {};

/**
 *  获取机票碳排放
 *  post /1.0.0/et/queryCarbonEmission
 * 
 *  @ApiModelProperty("舱位等级 Y-经济舱 F-头等/公务舱")
    private String cabin;

    @ApiModelProperty("原始排放量(单位:kg)")
    private Double preciseEmission;

    @ApiModelProperty("碳排放量(单位:kg)")
    private Double carbonEmission;

    @ApiModelProperty("航线碳排放标准值(单位:kg)")
    private Double carbonStandard;

    @ApiModelProperty("碳排放减少量(单位:kg)")
    private Double carbonReduction;

    @ApiModelProperty("碳排放减少率(百分比)")
    private Double carbonReductionRate;

    @ApiModelProperty("碳排放指标: LOW-较低, NORMAL-一般, HIGH-较高, VERY_HIGH-非常高")
    private String carbonIndicator;
 * 
 * **/ 
    tkCommonTpf.getCarbonEmissionListMap = (rangeItem = {},succFn,vueInstance)=>{
        // "arriveAirport": "string",
        // "departAirport": "string"
        let queryString = {
          "arriveAirport": rangeItem.arriveAirport,
          "departAirport": rangeItem.departAirport
        };
      
        if(rangeItem.flightNo){
          queryString.flightNoList = [rangeItem.flightNo];
        }
      
        if(rangeItem.flightNoList){
          queryString.flightNoList = rangeItem.flightNoList;
        }
      
        if (!queryString.arriveAirport || !queryString.departAirport) {
          return false
        };
        let queryUrl = 'tkQuery2023.queryCarbonEmission';
        vueInstance.$conn.getConn(queryUrl)(queryString,(res)=>{
          let data = res.data || {};
          let carbonEmissionList  = data  || {};
          succFn(carbonEmissionList)
        },(err)=>{
          succFn({})
        })
        // queryCarbonEmission(queryString).then(res=>{

      
        // }).catch(err=>{
     
         
        // })
      }
      // 匹配航班列表的 碳排放
      tkCommonTpf.getFlightItemCarbonEmission = (flightItem,carbonEmissionList = {})=>{
        let flightNo = flightItem.sharFlightNo || flightItem.flightNo;
      
        let cabinTypeCarbonList = carbonEmissionList[flightNo] || [];
        // 碳排放  Y-经济舱 F-头等/公务舱      
        // 系统舱位等级  Y C F  ES
        let cabinTypeList = flightItem.cabinTypeList.map(cabinTypeItem=>{
          let filterCarbonList = cabinTypeCarbonList.map(item=>{
            return {
              ...item,
              // 添加有效标记的字段
              cabinTypeCarbon:item.cabin,
            }
          }).filter(item=>{
            if(cabinTypeItem.cabinType == 'Y' || cabinTypeItem.cabinType == 'ES'){
              return item.cabin == 'Y'
            }
            if(cabinTypeItem.cabinType == 'C' || cabinTypeItem.cabinType == 'F'){
              return item.cabin == 'F'
            }
            return false  
          })
          let curCabinItem = filterCarbonList[0] || {};
          // 删除多余的字段
          delete curCabinItem.cabin
          return {
            ...cabinTypeItem,
            ...curCabinItem
          }
        })
      
        return {
          ...flightItem,
          cabinTypeList ,
        }
      
      
      }
      // 根据舱位等级类型 获取 TPF名称
      tkCommonTpf.getTPFNameByCabinType = (cabinType,cabinTypeList)=> {
      
        let filterTypeList = cabinTypeList.filter(cabinTypeItem=>{
          return cabinTypeItem.cabinType == cabinType
        }) ;
      
        let filterTypeItem = filterTypeList[0] || {};
      
        if(filterTypeItem.carbonIndicator){
          let carbonIndicator = '';
          carbonIndicator = filterTypeItem.carbonIndicator;
          return `碳排放量${tkCommonTpf.getTpfForCarbonIndicatorName(carbonIndicator)}`;
        }else{
          return '';
        }
      
      }
      // 根据CarbonIndicator 获取 TPF名称
      tkCommonTpf.getTpfForCarbonIndicatorName = (carbonIndicator)=>{
           // LOW - 较低, NORMAL - 一般 , HIGH - 较高, VERY_HIGH - 非常高
           const TPFMap = {
            'LOW':"较低",
            'NORMAL':"一般",
            'HIGH':"较高",
            'VERY_HIGH':"非常高",
        }
        return TPFMap[carbonIndicator]
      }


export default tkCommonTpf


